import React, { useState } from 'react';
import { registerUser } from '../components/Functions';
import Auth from '../components/Auth';
import Nav from '../components/Nav';
import '../css/Register.css';

const Register = () => {
  const [name, setName] = useState('');
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [isAdminLocal, setIsAdminLocal] = useState(false);
  const [confirmationMessage, setConfirmationMessage] = useState('');

  const handleRegister = async () => {
    const userData = {
      name: name,
      email: email,
      password: password,
      admin: isAdminLocal,
    };

    try {
      const response = await registerUser(userData);
      setConfirmationMessage('Usuario creado correctamente');
      console.log('Usuario registrado:', response);

      setName('');
      setEmail('');
      setPassword('');
      setIsAdminLocal(false);
    } catch (error) {
      console.error('Error al registrar el usuario:', error.message);
    }
  };

  return (
    <Auth>
      {({ nombreUsuario, isAdmin, handleLogout }) => (
        <div className="register-container">
          <Nav/>
          <h1 clas>Página de registro de usuarios</h1>
          <div className="form-container">
            <h2>Crear usuario</h2>
            <form className="register-form">
              <label htmlFor="name">Nombre:</label>
              <input
                type="text"
                id="name"
                value={name}
                onChange={(e) => setName(e.target.value)}
              />

              <label htmlFor="email">Email:</label>
              <input
                type="email"
                id="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
              />

              <label htmlFor="password">Password:</label>
              <input
                type="password"
                id="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
              />

              <label htmlFor="isAdmin">Admin:</label>
              <select
                id="isAdmin"
                value={isAdminLocal}
                onChange={(e) => setIsAdminLocal(e.target.value === 'true')}
              >
                <option value="false">No</option>
                <option value="true">Si</option>
              </select>

              <button type="button" onClick={handleRegister}>
                Registrar
              </button>
            </form>
            {confirmationMessage && <p>{confirmationMessage}</p>}
          </div>
        </div>
      )}
    </Auth>
  );
};

export default Register;
